import { createFileRoute } from "@tanstack/react-router";
import CuponsDeDesconto from "@/pages/CuponsDeDesconto";
import { seoHead } from "@/lib/seoHead";

const OG_IMAGE =
  "https://storage.googleapis.com/gpt-engineer-file-uploads/pOOf9Nrh78WhUebLRzOJgp5GbQl2/social-images/social-1779720587727-Design_sem_nome_-_2026-05-25T114758.465.webp";

export const Route = createFileRoute("/cupons-de-desconto")({
  head: () => {
    const monthYear = new Date().toLocaleDateString("pt-BR", { month: "long", year: "numeric" });
    const mY = monthYear.charAt(0).toUpperCase() + monthYear.slice(1);
    return seoHead({
      title: `Cupons de Desconto ${mY.replace(" de ", " ")} | Shopping do Bem`.slice(0, 60),
      description:
        "Encontre cupons de desconto válidos por loja, códigos exclusivos e ofertas de grandes marcas nacionais e internacionais.",
      canonical: "https://shoppingdobem.com.br/cupons-de-desconto",
      ogImage: OG_IMAGE,
    });
  },
  component: CuponsDeDesconto,
});
